export const environment = {
  production: false,
  version: '1.0',
  endpoint: {
    rs: 'https://rsqa.pagosapp.com.mx',
    multiuse: 'https://intrahub-qa.t-conecta.app:2503',
  },
  auth: {
    domain: 'portalrs.us.auth0.com',
    clientId: 'FJUL7nSCPPjOIoBvihd0EejSIPgtPXlS',
    audience: 'https://api.prueba-em-220525.com',
    redirectUri: window.location.origin,
    errorPath: 'https://d1zopn0np0hj26.cloudfront.net',
  },
  qtcAuth0: {
    clientId: 'V1Q2pfN0cPHH0SmDUuMpaUFFkRSiXWSz',
    clientSecret:
      'olR1TOdHt6y_y2g4Fpfs74QKAsIW1etstK6kVwZgRLNfCYdSVyQvkFtJvtlt7_0i',
    audience: 'https://portalrs.us.auth0.com/api/v2/',
  },
  cloudClientKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcm92aWRlclR5cGUiOiJhd3MiLCJwcm9qZWN0SWQiOiJwb3J0YWwtcnMiLCJlbnZpcm9ubWVudCI6IlFBIiwiaWF0IjoxNzgxODg3MzkxLCJleHAiOjE4MTM0NDQ5OTF9.l5TuMWuBXzJ-5MICTN52gsRj_w-a5Sg-HY_59PBnpIw',
  cloudCDN: 'dbakouofrzelo.cloudfront.net',
  tinymceApiKey: '4ekw6pj7z1sgjxd2rbmwmjpczwkml4j1dft3uda9ozv5nnmt',
};
